import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { ItemTipoSituacaoBadgeComponent } from './badge';
import { ItemTipoSituacaoPipe, ItemTipoSituacaoFilterPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ItemTipoSituacaoBadgeComponent,
        // Pipes
        ItemTipoSituacaoPipe,
        ItemTipoSituacaoFilterPipe
    ],
    exports: [
        ItemTipoSituacaoBadgeComponent,
        // Pipes
        ItemTipoSituacaoPipe,
        ItemTipoSituacaoFilterPipe
    ],
    providers: [
        // Pipes
        ItemTipoSituacaoPipe,
        ItemTipoSituacaoFilterPipe
    ]
})
export class ItemTipoSituacaoModule { }
